import { render, staticRenderFns } from "./addNameDialog.vue?vue&type=template&id=08618dd2&scoped=true"
import script from "./addNameDialog.vue?vue&type=script&lang=js"
export * from "./addNameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08618dd2",
  null
  
)

export default component.exports